import { JapaneseSymbol } from '../common/interfaces/japaneseSymbol'

export const HiraganaDictionary: JapaneseSymbol[] = [
  { symbol: 'あ', romaji: 'a' },
  { symbol: 'い', romaji: 'i' },
  { symbol: 'う', romaji: 'u' },
  { symbol: 'え', romaji: 'e' },
  { symbol: 'お', romaji: 'o' },
  { symbol: 'か', romaji: 'ka' },
  { symbol: 'き', romaji: 'ki' },
  { symbol: 'く', romaji: 'ku' },
  { symbol: 'け', romaji: 'ke' },
  { symbol: 'こ', romaji: 'ko' },
  { symbol: 'が', romaji: 'ga' },
  { symbol: 'ぎ', romaji: 'gi' },
  { symbol: 'ぐ', romaji: 'gu' },
  { symbol: 'げ', romaji: 'ge' },
  { symbol: 'ご', romaji: 'go' },
  { symbol: 'さ', romaji: 'sa' },
  { symbol: 'し', romaji: 'shi' },
  { symbol: 'す', romaji: 'su' },
  { symbol: 'せ', romaji: 'se' },
  { symbol: 'そ', romaji: 'so' },
  { symbol: 'ざ', romaji: 'za' },
  { symbol: 'じ', romaji: 'ji' },
  { symbol: 'ず', romaji: 'zu' },
  { symbol: 'ぜ', romaji: 'ze' },
  { symbol: 'ぞ', romaji: 'zo' },
  { symbol: 'た', romaji: 'ta' },
  { symbol: 'ち', romaji: 'chi' },
  { symbol: 'つ', romaji: 'tsu' },
  { symbol: 'て', romaji: 'te' },
  { symbol: 'と', romaji: 'to' },
  { symbol: 'だ', romaji: 'da' },
  { symbol: 'ぢ', romaji: 'dji' },
  { symbol: 'づ', romaji: 'dzu' },
  { symbol: 'で', romaji: 'de' },
  { symbol: 'ど', romaji: 'do' },
  { symbol: 'な', romaji: 'na' },
  { symbol: 'に', romaji: 'ni' },
  { symbol: 'ぬ', romaji: 'nu' },
  { symbol: 'ね', romaji: 'ne' },
  { symbol: 'の', romaji: 'no' },
  { symbol: 'は', romaji: 'ha' },
  { symbol: 'ひ', romaji: 'hi' },
  { symbol: 'ふ', romaji: 'fu' },
  { symbol: 'へ', romaji: 'he' },
  { symbol: 'ほ', romaji: 'ho' },
  { symbol: 'ば', romaji: 'ba' },
  { symbol: 'び', romaji: 'bi' },
  { symbol: 'ぶ', romaji: 'bu' },
  { symbol: 'べ', romaji: 'be' },
  { symbol: 'ぼ', romaji: 'bo' },
  { symbol: 'ぱ', romaji: 'pa' },
  { symbol: 'ぴ', romaji: 'pi' },
  { symbol: 'ぷ', romaji: 'pu' },
  { symbol: 'ぺ', romaji: 'pe' },
  { symbol: 'ぽ', romaji: 'po' },
  { symbol: 'ま', romaji: 'ma' },
  { symbol: 'み', romaji: 'mi' },
  { symbol: 'む', romaji: 'mu' },
  { symbol: 'め', romaji: 'me' },
  { symbol: 'も', romaji: 'mo' },
  { symbol: 'や', romaji: 'ya' },
  { symbol: 'ゆ', romaji: 'yu' },
  { symbol: 'よ', romaji: 'yo' },
  { symbol: 'ら', romaji: 'ra' },
  { symbol: 'り', romaji: 'ri' },
  { symbol: 'る', romaji: 'ru' },
  { symbol: 'れ', romaji: 're' },
  { symbol: 'ろ', romaji: 'ro' },
  { symbol: 'わ', romaji: 'wa' },
  { symbol: 'を', romaji: 'wo' },
  { symbol: 'ん', romaji: 'n' },
]

export const HSmallKanaDictionary: JapaneseSymbol[] = [
  { symbol: 'ぁ', romaji: '=a' },
  { symbol: 'ぃ', romaji: '=i' },
  { symbol: 'ぅ', romaji: '=u' },
  { symbol: 'ぇ', romaji: '=e' },
  { symbol: 'ぉ', romaji: '=o' },
  { symbol: 'っ', romaji: '=tsu' },
  { symbol: 'ゃ', romaji: '=ya' },
  { symbol: 'ゅ', romaji: '=yu' },
  { symbol: 'ょ', romaji: '=yo' },
]

export const HNVariantsDictionary: JapaneseSymbol[] = [
  { symbol: 'な', romaji: 'んa' },
  { symbol: 'に', romaji: 'んi' },
  { symbol: 'ぬ', romaji: 'んu' },
  { symbol: 'ね', romaji: 'んe' },
  { symbol: 'の', romaji: 'んo' },
]

export const HPunctuationDictionary: JapaneseSymbol[] = [
  { symbol: 'ー', romaji: '-' },
  { symbol: '。', romaji: '.' },
  { symbol: '、', romaji: ',' },
  { symbol: '「', romaji: '" ' },
  { symbol: '」', romaji: ' "' },
]
